import get from 'lodash/get';
import map from 'lodash/map';
import uniqBy from 'lodash/uniqBy';

export const getRetailerLocation = (selectedRetailer) => {
  return map(selectedRetailer, (retailer) => {
    return {
      label: get(retailer, 'name'),
      value: get(retailer, 'id'),
      children: map(get(retailer, 'Cities'), (city) => ({
        label: get(city, 'name'),
        value: get(city, 'id'),
      })),
    };
  });
};

export const getLocationTouchPoints = (selectedLocations = []) => {
  return map(selectedLocations, (location) => {
    return {
      label: get(location, 'name'),
      value: get(location, 'id'),
      children: map(get(location, 'Touchpoints'), (touchpoint) => ({
        label: get(touchpoint, 'name'),
        value: get(touchpoint, 'id'),
      })),
    };
  });
};

export const getTouchPointMeta = (touchPoints = []) => {
  const locations = [];
  const retailers = [];
  const campaignTouchPoints = [];

  map(touchPoints, (tp) => {
    campaignTouchPoints.push(get(tp, 'Touchpoint'));
    retailers.push(get(tp, 'Touchpoint.PartnerRetailer'));
    locations.push(get(tp, 'Touchpoint.TouchpointCity'));
  });

  return {
    locations: uniqBy(locations, 'id'),
    retailers: uniqBy(retailers, 'id'),
    campaignTouchPoints: uniqBy(campaignTouchPoints, 'id'),
  };
};
